module.exports = __webpack_public_path__ + "img/weddings_16_H.cbe31add.webp";